module.exports = global.config = {
  basePath: "/review"
};